import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Home from './application/components/pages/home'
import Estimates from './application/components/pages/estimate-compare'
import IndividualEstimate from './application/components/pages/estimate-details'
import ProceedEstimate from './application/components/pages/proceed-estimate'
import RequestCancellationPage from './application/components/pages/requestCancellationPage'

import ReviewProposal from './application/components/pages/proposal'
import ProposalAccepted from './application/components/pages/proposal/accepted'
import Login from './application/components/pages/login'
import Logout from './application/components/pages/logout'
import { Provider } from 'react-redux'
import CheckUserAccess from './application/components/checkUserAccess'
import ConsultantContainer from './application/containers/consultantContainer'
import ConsultantUserActivity from './application/containers/consultantUserActivity'
import Settlements from './application/components/pages/settlements'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './application/store/configureStore'
import NotFoundPage from './application/components/pages/notFoundPage.js'
import HttpsRedirect from 'react-https-redirect'
import PdfView from './application/components/pages/pdf/pdfView'
import './styles/style.scss'
import { ThemeProvider } from '@emotion/react'
import { GlobalStyles as MaxxiaGlobalStyles } from './Maxxia/globalStyles'
import { GlobalStyles as RemServGlobalStyles } from './RemServ/globalStyles'
import { theme as MaxxiaTheme } from './Maxxia/theme'
import { theme as RemServTheme } from './RemServ/theme'
function App() {
  // This is to clear all user data once the browser is closed
  // This event is also getting triggered on page refresh. Need to handle it in a way so that it is only triggered on closing the browser
  /*window.onbeforeunload = function (e) {
    localStorage.clear()
  }*/

  return (
    <HttpsRedirect>
      <Provider store={store}>
        <Router>
          <PersistGate persistor={persistor}>
            <CheckUserAccess />
            <ThemeProvider
              theme={
                global.config.brand == 'Maxxia' ? MaxxiaTheme : RemServTheme
              }
            >
              {global.config.brand == 'Maxxia' && (
                <MaxxiaGlobalStyles theme={MaxxiaTheme} />
              )}
              {global.config.brand == 'RemServ' && (
                <RemServGlobalStyles theme={RemServTheme} />
              )}
              <Switch>
                <Route
                  path={[
                    '/estimates/:estimateId',
                    '/consultant/estimates/:estimateId',
                  ]}
                  exact
                  component={IndividualEstimate}
                />
                <Route
                  path="/estimates/:estimateId/pdfview"
                  exact
                  component={() => <PdfView type="estimate" />}
                />
                <Route
                  path="/consultant/estimates/:estimateId/pdfview"
                  exact
                  component={() => <PdfView type="estimate" />}
                />
                <Route
                  path="/consultant/login"
                  exact
                  component={ConsultantContainer}
                />
                <Route
                  path="/consultant/useractivity"
                  exact
                  component={ConsultantUserActivity}
                />
                <Route path="/settlements" exact component={Settlements} />
                <Route
                  path="/consultant/settlements"
                  exact
                  component={Settlements}
                />
                <Route
                  path="/consultant/proposal/:estimateId/review/pdfview"
                  exact
                  component={() => <PdfView type="proposal" />}
                />
                <Route
                  path="/proposal/:estimateId/review/pdfview"
                  exact
                  component={() => <PdfView type="proposal" />}
                />
                <Route path="/login" exact component={Login} />
                <Route path="/logout/:opportunityId" exact component={Logout} />
                <Route
                  path={['/home', '/consultant/home']}
                  exact
                  component={Home}
                />
                <Route
                  path="/estimates/:estimateId/proceed"
                  exact
                  component={ProceedEstimate}
                />
                <Route
                  path="/estimates/:estimateId/proceed/cancelled"
                  exact
                  component={RequestCancellationPage}
                />
                <Route
                  path="/proposal/accepted"
                  exact
                  component={ProposalAccepted}
                />
                <Route
                  path="/proposal/acceptance/cancelled"
                  exact
                  component={RequestCancellationPage}
                />
                {/* <Route path="/quote/details" exact component={QuoteDetails} />
                <Route
                  path="/quote/details/pdfview"
                  exact
                  component={() => <PdfView type="proposal" />}
                /> */}

                <Route
                  path={[
                    '/proposal/:estimateId/review',
                    '/consultant/proposal/:estimateId/review',
                  ]}
                  exact
                  component={ReviewProposal}
                />
                <Route
                  path={['/consultant/estimates', '/estimates']}
                  exact
                  component={Estimates}
                />
                <Route path="*" component={NotFoundPage} />
              </Switch>{' '}
            </ThemeProvider>
          </PersistGate>
        </Router>
      </Provider>
    </HttpsRedirect>
  )
}

export default App
